export default "__VITE_ASSET__CLnPTM7M__"